// import React from "react";
// import EventsListPage from "./EventsListPage";

// const UpcomingEvents = ({ events, title }) => {
//   return (
//     <>
//       <EventsListPage events={events} title={title} />
//     </>
//   );
// };

// export default UpcomingEvents;

import React, { useEffect, useRef } from "react";
import EventsListPage from "./EventsListPage";
import { Calendar, ArrowRight, Sparkles } from "lucide-react";

const UpcomingEvents = ({ events, title }) => {
  const eventRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (eventRef.current) {
        eventRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center shadow-2xl">
                <Calendar className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Upcoming{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Events</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-400 to-lime-400 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl text-emerald-100 max-w-3xl mx-auto mb-8">
            Discover exciting golf tournaments, social gatherings, and exclusive
            member events coming soon at RGCC
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-emerald-200">
              <Sparkles className="w-5 h-5" />
              <span>Exclusive Access</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <ArrowRight className="w-5 h-5" />
              <span>Register Early</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <Calendar className="w-5 h-5" />
              <span>Member Priority</span>
            </div>
          </div>
        </div>
      </div>

      {/* Events List */}
      <div ref={eventRef}>
        <EventsListPage events={events} title={title} />
      </div>
    </div>
  );
};

export default UpcomingEvents;
